import i18n from 'scoreboard/components/i18n'
import _ from 'lodash'

var invalidCharacters = ['&', '<', '>', '"', "'"]

/**
 * Validates a string for presence of HTML special characters.
 * Returns an error message if any invalid character is found.
 * Used to validate input of the configurable terminology replacements
 * in the application administration page. #55589
 *
 * @param {string} val - The string to validate
 * @returns {string|undefined} Error message if invalid, undefined if valid
 */
function configurableTerminologyValidator(val) {
	if (_.isEmpty(val)) {
		return
	}
	for (let i = 0; i < val.length; i++) {
		const char = val.charAt(i)
		if (invalidCharacters.includes(char)) {
			return i18n.get('admin.terminology.invalid', invalidCharacters.join(' '))
		}
	}
}

export default configurableTerminologyValidator
configurableTerminologyValidator.__filename__ = 'admin/configuration/configurable-terminology-validator.js'
